
// 获取用户套餐信息
import { tools } from '@wenjuan/business'
import { mapState } from 'vuex'
import { httpMemberPackageInfo } from '~/api/common.js'
import { sendPayClue } from '~/api/package-about.js'
import { createObserver } from '~/utils/tools.js'

export default {
  name: 'ScencePro',
  layout: 'scence-single',
  data() {
    return {
      // 设备类型
      deviceType: 'min',
      //   轮播卡片
      carouselData: [
        { advice: '“做品牌活动用问卷网会是一种很新颖的模式,你觉得呢？”', user: '葱头 爱奇艺市场部渠道中台' },
        { advice: '“问卷网，民意调查的好帮手！”', user: '高志广 沈阳日报编委兼内参舆情中心主任' },
        { advice: '“每日的用户满意度调研都离不开问卷网。”', user: 'Leslie 小程序运营' },
        { advice: '“功能齐全，页面美观，使用便捷。”', user: '任老师 心理学部MAP中心宣传负责人' },
        { advice: '“问卷网协助我们更好的了解用户需求”', user: 'Mocca 品牌运营' },
      ],
      //   轮播商标logo
      carouselImglist: [
        {
          img: require('@/assets/image/pro/pc/carousel-1.png'),
        },
        {
          img: require('@/assets/image/pro/pc/carousel-2.png'),
        },
        {
          img: require('@/assets/image/pro/pc/carousel-3.png'),
        },
        {
          img: require('@/assets/image/pro/pc/carousel-4.png'),
        },
        {
          img: require('@/assets/image/pro/pc/carousel-5.png'),
        },
      ],
      //   帮助数据
      visitData: {
        rspdCountTotal: 19.3,
        memberCountTotal: 2339,
      },
      //   pc轮播卡片
      partnerList: [
        {
          name: '葱头',
          job: '爱奇艺市场部渠道中台',
          word: '做品牌活动用问卷网会是一种很新颖的模式。',
        },
        {
          name: '高志广',
          job: '沈阳日报编委兼内参舆情中心主任',
          word: '问卷网，民意调查的好帮手！',
        },
        {
          name: 'Leslie',
          job: '小程序运营',
          word: '每日的用户满意度调研都离不开问卷网。',
        },
        {
          name: '任老师',
          job: '心理学部MAP中心宣传负责人',
          word: '功能齐全，页面美观，使用便捷。',
        },
        {
          name: 'Mocca',
          job: '品牌运营',
          word: '问卷网协助我们更好地了解用户需求。',
        },
      ],
      isBlank: false,
      // 是否显示登录框
      showLoginPopup: false,
      // 登录弹框配置数据
      loginPopConfig: {
        type: 'register-login',
        nexturl: '/pro',
      },
      packageDialog: '', // 用于保存动态引入的package-dialog.js
      timer: null,
      memberPKGInfo: {}, // 当前用户套餐信息
      packData: {
        show: false,
      },
      imgHeight: 'auto',
    }
  },
  fetchOnServer: false,
  async fetch() {
    try {
      if (this.haslogin == 0) return false
      const res = await httpMemberPackageInfo()
      if (res.originData.status_code == 1) this.memberPKGInfo = res.data
      // try_enterprise_ultimate_free_version 是不是试用版
      this.$store.commit('setUserTry', res.data.try_enterprise_ultimate_free_version)
      if (!res.data.package_status || res.data.package_status.version == 'advance_version') {
        this.$store.commit('setUserCombo', 0)
      } else {
        this.$store.commit('setUserCombo', 1)
      }
    } catch (error) {}
  },
  head: {
    title: '问卷网企业版_企业级的问卷调研·报名表单·考试测评功能与服务',
    link: [{ rel: 'canonical', href: 'https://www.wenjuan.com/pro/' }],
    meta: [
      {
        hid: 'keywords',
        name: 'keywords',
        content: '企业版,企业旗舰版,基础版,免费版,高级版,定制版,调查问卷,问卷调查,问卷网',
      },
      {
        hid: 'description',
        name: 'description',
        content: '问卷网企业版给用户提供企业级的问卷调研·报名表单·考试测评功能与服务，已服务上千家企业。',
      },
    ],
    script: [{ src: '//s1.wenjuan.com/lib/jquery/1.8.3/jquery.min.js' }],
  },
  computed: {
    microAppInfo() {
      return tools.$ENV.defineState()
    },
    ...mapState(['isMobile']),
    ...mapState({ type: 'usercomboType', isFree: 'isFreeTry', width: 'clientWidth' }),
    isShowApply() {
      return !this.isFree && (!(this.haslogin == 0) || this.type == 0)
    },
    loggedIn() {
      return this.$store.loginStatus.loggedIn == 1
    },
    haslogin() {
      return this.$store.state.loginStatus.loggedIn
    },
  },
  watch: {
    // 监听页面宽度
    width(val) {
      if (this.width < 657) {
        this.deviceType = 'min'
      } else {
        this.deviceType = 'max'
      }
    },
  },
  mounted() {
    this.doSendPayClue()
    this.isMobile && this.autoGetBoundingClientRect()
  },
  methods: {
    doSendPayClue() {
      if (this.haslogin == 0) {
        return
      }
      const _stayTimer = setTimeout(function () {
        clearTimeout(_stayTimer)
        // 发送付费套餐线索
        sendPayClue({
          clue_tag_list: ['浏览企业版落地页'],
          clue_resource: '浏览套餐相关页面',
        })
      }, 30000)
    },
    applyEnterpriseVersion() {
      if (this.haslogin != 0) {
        if (this.type == 0) {
          // 普通用户  申请试用页
          this.isBlank = true
          return 'https://www.wenjuan.com/s/UZBZJvX9GO6/?user=mobile'
        }
        if (this.type == 1) {
          this.isBlank = false
          // 进入问卷网  项目列表页
          return '/list/'
        }
      } else {
        this.isBlank = false
        // 登录页
        return '/m/login/'
      }
    },
    concatOnline() {
      window.ysf && window.open(window.ysf('url'))
    },
    // 登录弹窗
    showLogin() {
      if (this.haslogin == 0) {
        this.$store.commit('setLoginStatus', { show: true })
      }
    },
    // 购买弹窗
    async buyEnterpriseVersion() {
      if (this.haslogin == 0) {
        this.$store.commit('setLoginStatus', { show: true })
      } else {
        const res = await httpMemberPackageInfo()
        const { data, status_code: statusCode, status } = res.originData
        this.$store.commit('member/setPackageInfo', data)
        if (statusCode === 1 && status === 200) {
          const version =
            data.package_status?.version === 'enterprise_ultimate_version'
              ? 'enterprise_ultimate_version'
              : 'enterprise_version'
          this.openPackageDialog(version)
        }
      }
    },
    // 申请试用版本
    applyFreeTry() {
      if (this.haslogin == 0) {
        return ''
      } else {
        this.isBlank = true
        return 'https://www.wenjuan.com/s/UZBZJvX9GO6/?user=mobile'
      }
    },
    autoGetBoundingClientRect() {
      this.imgHeight = ~~((window.innerWidth * 570) / 414) + 'px'
      const dom = document.querySelector('#fott')
      dom &&
        createObserver({
          type: 'resize',
        })
          .add(dom)
          .then((data) => {
            this.imgHeight = ~~(data.width * 570) / 414 + 'px'
          })
    },
    // 打开购买弹窗
    openPackageDialog(version) {
      this.$store.commit('setPackageDialog', {
        show: true,
        activeVersion: version,
        lowestVersion: version,
        source: '数据限制',
        excludes: ['advance_version'], // 强制移除版本号
      })
    },
  },
}
